/* import __COLOCATED_TEMPLATE__ from './mcp-actions-collapsible-list.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type ThemeService from 'embercom/services/theme-service';
import {
  getMcpTemplateByName,
  getListIconForMcpServer,
} from 'embercom/models/workflow-connector/constants/mcp-templates';
import type McpServer from 'embercom/models/workflow-connector/mcp-server';

interface Args {
  title: string | null;
  target: string;
  actions: any[];
  selectedColumns: any[];
  onAddActionClick: () => void;
  isInitiallyOpen: boolean;
  mcpServer?: McpServer;
  showEditOrDeleteMcpServerModal?: (mcpServer: McpServer) => void;
  isDefaultDataConnector?: boolean;
}

export default class McpActionsCollapsibleList extends Component<Args> {
  @service declare intl: IntlService;
  @service declare themeService: ThemeService;

  @tracked isOpen;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.isOpen = this.args.isInitiallyOpen ?? false;
  }

  get arrowIconClass() {
    return this.isOpen ? 'small-up-arrow' : 'small-down-arrow';
  }

  get mcpServerIcon(): string {
    if (this.args.isDefaultDataConnector) {
      return 'mcp/default';
    }

    return getListIconForMcpServer(
      this.args.mcpServer?.name ?? '',
      this.themeService.darkModeEnabled,
    );
  }

  get mcpServerDescription(): string | null {
    let descriptionKey = this.getMcpServerDescriptionKey();
    return descriptionKey ? this.intl.t(descriptionKey) : null;
  }

  private getMcpServerDescriptionKey(): string | null {
    if (this.args.mcpServer?.name === 'default_connectors') {
      return 'workflow-connector.actions.data-connectors-description';
    }

    if (this.args.mcpServer?.name) {
      let template = getMcpTemplateByName(this.args.mcpServer.name);
      if (template) {
        return template.descriptionKey;
      }
    }

    return null;
  }

  @action
  toggleCollapse() {
    this.isOpen = !this.isOpen;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::McpActionsCollapsibleList': typeof McpActionsCollapsibleList;
    'workflow-connector/mcp-actions-collapsible-list': typeof McpActionsCollapsibleList;
  }
}
